<div class="terms">
  @if (data$ | async; as data) {
  <div [ngClass]="'labelTC' + (businessType | titlecase)">
    @if (activeCountry$ | async; as country) { @if (countryTermsSetting(country, activeLanguage$ | async); as
    termsCondition) {
    <h1 [ngClass]="getClass(country)">
      {{ 'termsConditions.termsConditionsLabel' + termsCondition?.tcLabel | cxTranslate }}
    </h1>
    @if (currentDate && termsCondition?.showDate) {
    <p class="updated-date">
      {{ 'termsConditions.lastUpdated' + termsCondition?.tcLastUpdated | cxTranslate }}
      <span>{{
        currentDate
          | date
            : ((showDynamicDateFormat$ | async) || (country === 'es' && businessType === 'fish')
                ? (dateFormat$ | async)
                : 'yyyy/MM/dd')
      }}</span>
    </p>
    } } }
    <p [innerHTML]="data.content"></p>
  </div>
  }
</div>
